<div class="container ">
  <app-shared-action-bar [saveReady]="changeOccured && !isSaving" [undoReady]="changeOccured"
    [displayActionSectionBar]="showActionSectionBar" (saveRequest)="validateChanges()"
  (undoRequest)="resetPage()"></app-shared-action-bar>




  <div class="px-4 md:px-8 mt-20">
    <h2 class="settings-header">{{ 'audit' | customerTerm }} Locations</h2>
    @if (!displayLocations) {
      <div class="mt-4 ">
        <p class="text-2xl font-bold">Select {{ 'audit' | customerTerm }}</p>
        <select class="mt-2 mr-4 text-box xl:w-3/5" [(ngModel)]="selectedAuditType"
          [compareWith]="auditTypeComparison" (change)="updateAuditList()">
          @for (a of auditTypeList; track a) {
            <option [ngValue]="a">{{a.Description}}</option>
          }
        </select>
        <select class="mt-2 mr-4 text-box xl:w-3/5" [(ngModel)]="selectedAudit" [compareWith]="auditComparison"
          >
          @for (a of displayAuditList; track a) {
            <option [disabled]="a.AuditID == -1" [ngValue]="a">{{a.AuditName}}
            </option>
          }
        </select>
        <button (click)="selectAudit()" class="btn-primary mt-4">Load</button>
      </div>
    }
    @if (locationsLoaded && displayLocations) {
      <div class="lg:mx-6 mx-4 mt-6">
        <div class="mt-4 flex items-center" >
          <p class="settings-selected-item mr-2">{{selectedAudit.AuditName}} </p><span (click)="showDDL()"
          class="hover:cursor-pointer text-xl material-symbols-outlined">
          edit
        </span>
      </div>
      <table class="mt-6">
        <tbody>
          <tr class="border-b-offblack border-b-2 mb-2 py-1">
            <td class="font-bold">All</td>
            <td class="flex justify-center py-2 pl-3">
              <app-toggle-switch [(checked)]="allPermissions"
              (checkedChange)="updateAllPermissions()"></app-toggle-switch>
            </td>
          </tr>
          @for (p of locationsList.Locations; track p; let i = $index) {
            <tr>
              <td
                [ngClass]="{'pl-1':p.LocationLevelSeq==minLocationLevel+1,'pl-3':p.LocationLevelSeq==minLocationLevel+2,'pl-6':p.LocationLevelSeq==minLocationLevel+3,'pl-8':p.LocationLevelSeq==minLocationLevel+4}">
              {{p.LocationName}}</td>
              <td class="flex justify-center py-2 pl-3">
                <app-toggle-switch [(checked)]="p.AssignedToAudit"
                (checkedChange)="locationChanged(p)"></app-toggle-switch>
              </td>
            </tr>
          }
        </tbody>
      </table>

  </div>
}
</div>
